import { AdminRoutes, RegexMatch } from "@/data/enums/router";
import type { NavigationGuardNext, Route } from "vue-router";
import type { CreateElement } from "vue";
import ContractProductsComponent from "@/views/admin/contractProducts/index.vue";
import _ from "lodash";
import { OrgFeatureKeys } from "@upmind-automation/types";
import store from "@/store";
import { DataModules } from "@/store/modules/data/modules";

export default [
  {
    path: `cp/:id(${RegexMatch.UUID})`,
    name: AdminRoutes.CONTRACT_PRODUCT_REDIRECT,
    component: {
      name: "AdminCPRedirect",
      render(h: CreateElement) {
        return h("loading", {
          props: {
            isAbsolute: true
          }
        });
      }
    },
    beforeEnter: async (to: Route, from: Route, next: NavigationGuardNext) => {
      try {
        const contractProduct = await store.dispatch(
          `data/${DataModules.CONTRACTS_PRODUCTS}/get`,
          { id: to.params.id, params: { with: null } } // We don't need relations for the redirect
        );

        return next({
          name: AdminRoutes.CONTRACT_PRODUCT,
          params: {
            clientId: contractProduct?.client_id,
            contractId: contractProduct?.contract_id,
            productId: contractProduct?.id
          },
          replace: true
        });
      } catch (error) {
        store.dispatch("api/handleError", error);
        return next({
          name: AdminRoutes.DASHBOARD,
          replace: true
        });
      }
    }
  },
  {
    path: "products/bulk-actions",
    component: {
      name: "AdminProductBulkActions",
      template: `<router-view />`
    },
    meta: {
      requiredFeatureKeys: [OrgFeatureKeys.BULK_NOTIFICATIONS_ENABLED]
    },
    redirect: { name: "adminProductBulkNotifications" },
    children: [
      {
        path: "",
        name: "adminProductBulkNotifications",
        component: () =>
          import("@/views/admin/contractProducts/bulkActions/index.vue"),
        meta: {
          auth: ["list_notification_channels"]
        }
      },
      {
        path: `:bulkActionId(${RegexMatch.UUID})`,
        name: "adminProductBulkActionsEdit",
        redirect: { name: "adminCProdsBulkActionOverview" },
        component: () =>
          import(
            "@/views/admin/contractProducts/bulkActions/bulkAction/index.vue"
          ),
        props: (to: Route) => {
          return {
            bulkActionId: to.params.bulkActionId,
            routes: require("./menu").bulkActionTabigation
          };
        },
        children: [
          {
            path: "overview",
            name: "adminCProdsBulkActionOverview",
            component: () =>
              import(
                "@/views/admin/contractProducts/bulkActions/bulkAction/overview/index.vue"
              )
          },
          {
            path: "logs",
            name: "adminCProdsBulkActionLogs",
            component: () =>
              import(
                "@/views/admin/contractProducts/bulkActions/bulkAction/logs/index.vue"
              )
          },
          {
            path: "activity-log",
            name: "adminCProdsBulkActionActivityLog",
            component: () =>
              import(
                "@/views/admin/contractProducts/bulkActions/bulkAction/activityLog/index.vue"
              )
          }
        ]
      }
    ]
  },
  {
    path: "products/bulk-operations",
    alias: "products/bulk-updates",
    name: AdminRoutes.CPROD_BULK_OPERATIONS,
    component: () =>
      import("@/views/admin/contractProducts/scheduledActions/index.vue"),
    meta: {
      auth: ["list_contract_product_scheduled_actions"],
      requiresBrand: true
    }
  },
  {
    path: "products",
    name: "adminProductsAndServices",
    redirect: { name: "adminCProds" },
    component: {
      name: "AdminProductsAndServices",
      render(h: CreateElement) {
        return h(ContractProductsComponent, {
          props: {
            routes: require("./menu").contractProductsTabigation
          }
        });
      }
    },
    children: _.concat(
      require("./subscriptions").default,
      require("./otps").default,
      /**
       * Important! Must be injected after OTP and Subscriptions
       */
      require("./all").default
    )
  }
];
